<template>
   <div class="view-associated-reflection-for-group container-fluid"> 
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc padding-left-4Point4">
                </div>    
                <div class="col-md-5 col-lg-5">
                  <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="closeCurrentOverlay">
                    <img src= "../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row margin-left-2Perc">
                  <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
                    {{getSelectedGroupObjValue.GroupName}}
                  </div>
                  <div class="col-md-12 col-lg-12 text-align-left create-element-overlay-course-title-font-styles">
                  </div>
                  <div class="col-md-12 col-lg-12 text-align-right bottom-border">
                    Total Associated LEAPS Reflection Question(s): <b>{{this.leapsReflectionList.length}}</b>
                </div>     
              </div>
              <div class="row margin-left-2Perc margin-bottom-2Perc margin-Top-1Point5Perc">
                <div class="col-md-12 col-lg-12 text-align-left">
                  <span class="font-wight-bold font-size-16px"><u>* Not Used:</u></span>
                  <span @click="addNewReflectionQuestion(1)" class="cursor-pointer margin-right-2Perc float-right border-1px-solid-blue">
                    <span class="glyphicon glyphicon-plus-sign text-color-blue font-size-14px"></span>    
                    <span class="text-color-blue font-size-14px">Add New</span>
                  </span>
                </div>  
              </div>

              <div class="table-responsive margin-top-3Perc margin-left-2Perc margin-right-2Perc"  v-if="leapsOneRatingList.length > 0">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="text-align-center font-size-15px border-right col-md-1 col-lg-1">SR. No.</th>
                      <th class="text-align-center font-size-15px border-right col-md-9 col-lg-9">Question Text</th>
                      <th class="text-align-center font-size-15px col-md-2 col-lg-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(leapsOneRatingQueObj, index) in leapsOneRatingList" :key="leapsOneRatingQueObj.MeetingMentorReflectionId">
                      <td class="border-right col-md-1 col-lg-1">{{(index + 1)}}.</td>
                      <td class="border-right col-md-9 col-lg-9 text-wrap text-align-left">
                        <div class="row vertical-align">
                          <div class="col-md-11 col-lg-11">
                            <div>
                              <span v-if="!leapsOneRatingQueObj.showIndexEditTextBox">
                                <span><b><u>Index:</u></b></span>
                                <span>{{leapsOneRatingQueObj.Index}}</span>
                              </span>
                              <span v-else>
                                <div class="row"> 
                                  <div class="col-md-3 col-lg-3 margin-top-0Point5Perc font-color-blue">
                                    <div class="form-group margin-bottom-0px">
                                      <span class="font-size-11px">Index:</span>
                                      <span><input type="text" class="form-control" v-model="leapsOneRatingQueObj.updatedIndex"/></span>
                                    </div>
                                  </div>
                                  <div class="col-md-9 col-lg-9"></div>
                                </div>
                              </span>
                            </div>
                            <div>
                              <span v-if="!leapsOneRatingQueObj.showLongQueEditTextBox">
                                <span><b><u>Long Question:</u></b></span>
                                <span>{{leapsOneRatingQueObj.LongQuestion}}</span>         
                              </span>
                              <span v-else>
                                <div class="row"> 
                                  <div class="col-md-12 col-lg-12 margin-top-0Point5Perc font-color-blue">
                                    <div class="form-group margin-bottom-0px">
                                      <span class="font-size-11px">Long Question:</span>
                                      <span><textarea class="form-control" rows="2" v-model="leapsOneRatingQueObj.updatedLongQuestionText" maxlength="1024"></textarea></span>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </div>
                            <div>
                              <span v-if="!leapsOneRatingQueObj.showShortQueEditTextBox">
                                <span><b><u>Short Question:</u></b></span>
                                <span>{{leapsOneRatingQueObj.ShortQuestion}}</span>
                              </span>
                              <span v-else>
                                <div class="row"> 
                                  <div class="col-md-12 col-lg-12 margin-top-0Point5Perc font-color-blue">
                                    <div class="form-group margin-bottom-0px">
                                      <span class="font-size-11px">Short Question:</span>
                                      <span><textarea class="form-control" rows="2" v-model="leapsOneRatingQueObj.updatedShortQuestionText" maxlength="1024"></textarea></span>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </div>
                          </div>
                          <div class="col-md-1 col-lg-1" v-if="leapsOneRatingQueObj.showShortQueEditTextBox">
                            <span class="glyphicon glyphicon-remove-sign cursor-pointer" @click="showQuestionTextUser(leapsOneRatingQueObj, 1)"></span>    
                            <span class="glyphicon glyphicon-ok-sign cursor-pointer" @click="updateQuestion(leapsOneRatingQueObj)"></span>    
                          </div>
                          <div class="col-md-1 col-lg-1" v-else></div>
                        </div>
                      </td>
                      <td class="col-md-2 col-lg-2">
                        <a class="cursor-pointer " @click="performClickOperation($event,'edit-reflection', leapsOneRatingQueObj, 1)"> <u>Edit</u> </a> |
                        <a class="cursor-pointer " @click="performClickOperation($event,'delete-reflection', leapsOneRatingQueObj, 1)"> <u>Delete</u> </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="margin-top-3Perc margin-bottom-2Perc font-size-15px" v-else>
                No Associated LEAPS Reflection(s) found.
              </div>
              <hr width="90%" size="5px">
              <div class="row margin-left-2Perc margin-bottom-2Perc margin-Top-1Point5Perc">
                <div class="col-md-12 col-lg-12 text-align-left font-size-16px">
                  <span class="font-wight-bold font-size-16px font-wight-bold"><u>* Rating 1 - 2 with Min 1 selection of Very or Somewhat Effective:</u></span>
                  <span @click="addNewReflectionQuestion(2)" class="cursor-pointer margin-right-2Perc float-right border-1px-solid-blue">
                    <span class="glyphicon glyphicon-plus-sign text-color-blue font-size-14px"></span>    
                    <span class="text-color-blue font-size-14px">Add New</span>
                  </span>
                </div>  
                <div class="col-md-6 col-lg-6">
                </div>
              </div>
              <div class="table-responsive margin-top-3Perc margin-left-2Perc margin-right-2Perc" v-if="leapsTwoRatingList.length > 0">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="text-align-center font-size-15px border-right col-md-1 col-lg-1">SR. No.</th>
                      <th class="text-align-center font-size-15px border-right col-md-9 col-lg-9">Question Text</th>
                      <th class="text-align-center font-size-15px col-md-2 col-lg-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(leapsTwoRatingQueObj, index) in leapsTwoRatingList" :key="leapsTwoRatingQueObj.MeetingMentorReflectionId">
                      <td class="border-right col-md-1 col-lg-1">{{(index + 1)}}.</td>
                      <td class="border-right col-md-9 col-lg-9 text-wrap text-align-left">
                        <div class="row vertical-align">
                          <div class="col-md-11 col-lg-11">
                            <div>
                              <span v-if="!leapsTwoRatingQueObj.showIndexEditTextBox">
                                <span><b><u>Index:</u></b></span>
                                <span>{{leapsTwoRatingQueObj.Index}}</span>
                              </span>
                              <span v-else>
                                <div class="row"> 
                                  <div class="col-md-3 col-lg-3 margin-top-0Point5Perc font-color-blue">
                                    <div class="form-group margin-bottom-0px">
                                      <span class="font-size-11px">Index:</span>
                                      <span><input type="text" class="form-control" v-model="leapsTwoRatingQueObj.updatedIndex"/></span>
                                    </div>
                                  </div>
                                  <div class="col-md-9 col-lg-9"></div>
                                </div>
                              </span>
                            </div>
                            <div>
                              <span v-if="!leapsTwoRatingQueObj.showLongQueEditTextBox">
                                <span><b><u>Long Question:</u></b></span>
                                <span>{{leapsTwoRatingQueObj.LongQuestion}}</span>         
                              </span>
                              <span v-else>
                                <div class="row"> 
                                  <div class="col-md-12 col-lg-12 margin-top-0Point5Perc font-color-blue">
                                    <div class="form-group margin-bottom-0px">
                                      <span class="font-size-11px">Long Question:</span>
                                      <span><textarea class="form-control" rows="2" v-model="leapsTwoRatingQueObj.updatedLongQuestionText" maxlength="1024"></textarea></span>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </div>
                            <div>
                              <span v-if="!leapsTwoRatingQueObj.showShortQueEditTextBox">
                                <span><b><u>Short Question:</u></b></span>
                                <span>{{leapsTwoRatingQueObj.ShortQuestion}}</span>
                              </span>
                              <span v-else>
                                <div class="row"> 
                                  <div class="col-md-12 col-lg-12 margin-top-0Point5Perc font-color-blue">
                                    <div class="form-group margin-bottom-0px">
                                      <span class="font-size-11px">Short Question:</span>
                                      <span><textarea class="form-control" rows="2" v-model="leapsTwoRatingQueObj.updatedShortQuestionText" maxlength="1024"></textarea></span>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </div>
                          </div>
                          <div class="col-md-1 col-lg-1" v-if="leapsTwoRatingQueObj.showShortQueEditTextBox">
                            <span class="glyphicon glyphicon-remove-sign cursor-pointer" @click="showQuestionTextUser(leapsTwoRatingQueObj, 2)"></span>    
                            <span class="glyphicon glyphicon-ok-sign cursor-pointer" @click="updateQuestion(leapsTwoRatingQueObj)"></span>    
                          </div>
                          <div class="col-md-1 col-lg-1" v-else></div>
                        </div>
                      </td>
                      <td class="col-md-2 col-lg-2">
                        <a class="cursor-pointer " @click="performClickOperation($event,'edit-reflection', leapsTwoRatingQueObj, 2)"> <u>Edit</u> </a> |
                        <a class="cursor-pointer " @click="performClickOperation($event,'delete-reflection', leapsTwoRatingQueObj, 2)"> <u>Delete</u> </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="margin-top-3Perc margin-bottom-2Perc font-size-15px" v-else>
                No Associated LEAPS Reflection(s) found.
              </div>
              <hr width="90%" size="10px">
              <div class="row margin-left-2Perc margin-bottom-2Perc margin-Top-1Point5Perc">
                <div class="col-md-12 col-lg-12 text-align-left font-size-16px">
                  <span class="font-wight-bold font-size-16px font-wight-bold"><u>* Rating 3 - 5 with Min 1 selection of Very or Somewhat Effective:</u></span>
                  <span @click="addNewReflectionQuestion(3)" class=" cursor-pointer margin-right-2Perc float-right border-1px-solid-blue">
                    <span class="glyphicon glyphicon-plus-sign text-color-blue font-size-14px"></span>    
                    <span class="text-color-blue font-size-14px">Add New</span>
                  </span>
                </div>  
                <div class="col-md-6 col-lg-6">
                </div>
              </div>
              <div class="table-responsive margin-top-3Perc margin-left-2Perc margin-right-2Perc"  v-if="leapsThreeRatingList.length > 0">
                <table class="table table-striped">
                    <thead>
                    <tr>
                      <th class="text-align-center font-size-15px border-right col-md-1 col-lg-1">SR. No.</th>
                      <th class="text-align-center font-size-15px border-right col-md-9 col-lg-9">Question Text</th>
                      <th class="text-align-center font-size-15px col-md-2 col-lg-2">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(leapsThreeRatingQueObj, index) in leapsThreeRatingList" :key="leapsThreeRatingQueObj.MeetingMentorReflectionId">
                      <td class="border-right col-md-1 col-lg-1">{{(index + 1)}}.</td>
                      <td class="border-right col-md-9 col-lg-9 text-wrap text-align-left">
                        <div class="row vertical-align">
                          <div class="col-md-11 col-lg-11">
                            <div>
                              <span v-if="!leapsThreeRatingQueObj.showIndexEditTextBox">
                                <span><b><u>Index:</u></b></span>
                                <span>{{leapsThreeRatingQueObj.Index}}</span>
                              </span>
                              <span v-else>
                                <div class="row"> 
                                  <div class="col-md-3 col-lg-3 margin-top-0Point5Perc font-color-blue">
                                    <div class="form-group margin-bottom-0px">
                                      <span class="font-size-11px">Index:</span>
                                      <span><input type="text" class="form-control" v-model="leapsThreeRatingQueObj.updatedIndex"/></span>
                                    </div>
                                  </div>
                                  <div class="col-md-9 col-lg-9"></div>
                                </div>
                              </span>
                            </div>
                            <div>
                              <span v-if="!leapsThreeRatingQueObj.showLongQueEditTextBox">
                                <span><b><u>Long Question:</u></b></span>
                                <span>{{leapsThreeRatingQueObj.LongQuestion}}</span>         
                              </span>
                              <span v-else>
                                <div class="row"> 
                                  <div class="col-md-12 col-lg-12 margin-top-0Point5Perc font-color-blue">
                                    <div class="form-group margin-bottom-0px">
                                      <span class="font-size-11px">Long Question:</span>
                                      <span><textarea class="form-control" rows="2" v-model="leapsThreeRatingQueObj.updatedLongQuestionText" maxlength="1024"></textarea></span>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </div>
                            <div>
                              <span v-if="!leapsThreeRatingQueObj.showShortQueEditTextBox">
                                <span><b><u>Short Question:</u></b></span>
                                <span>{{leapsThreeRatingQueObj.ShortQuestion}}</span>
                              </span>
                              <span v-else>
                                <div class="row"> 
                                  <div class="col-md-12 col-lg-12 margin-top-0Point5Perc font-color-blue">
                                    <div class="form-group margin-bottom-0px">
                                      <span class="font-size-11px">Short Question:</span>
                                      <span><textarea class="form-control" rows="2" v-model="leapsThreeRatingQueObj.updatedShortQuestionText" maxlength="1024"></textarea></span>
                                    </div>
                                  </div>
                                </div>
                              </span>
                            </div>
                          </div>
                          <div class="col-md-1 col-lg-1" v-if="leapsThreeRatingQueObj.showShortQueEditTextBox">
                            <span class="glyphicon glyphicon-remove-sign cursor-pointer" @click="showQuestionTextUser(leapsThreeRatingQueObj, 3)"></span>    
                            <span class="glyphicon glyphicon-ok-sign cursor-pointer" @click="updateQuestion(leapsThreeRatingQueObj)"></span>    
                          </div>
                          <div class="col-md-1 col-lg-1" v-else></div>
                        </div>
                      </td>
                      <td class="col-md-2 col-lg-2">
                        <a class="cursor-pointer " @click="performClickOperation($event,'edit-reflection', leapsThreeRatingQueObj, 3)"> <u>Edit</u> </a> |
                        <a class="cursor-pointer " @click="performClickOperation($event,'delete-reflection', leapsThreeRatingQueObj, 3)"> <u>Delete</u> </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="margin-top-3Perc margin-bottom-2Perc font-size-15px" v-else>
                No Associated LEAPS Reflection(s) found.
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="closeCurrentOverlay">Close</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <loader></loader>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="userConfirmation"></confirmation-alert>
    </div> 
</template>
<script>
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import AlertBox from '@/components/AlertOverlay'
import { constants } from '@/utils/constants'
import Loader from '@/components/dashboard/Loader'
import {forEach, findIndex, filter, sortBy} from 'lodash'
import { leapsChallengesService } from '@/server-util/leaps-challenges-service'

export default {
  props: ['selectedGroupObj'],
  name: 'view-associated-reflection-for-group',
  created () {
    this.performInitOperations()
    this.getLeapsReflectionList()
  },
  data: function () {
    return {
      leapsReflectionList: [],
      leapsOneRatingList: [],
      leapsTwoRatingList: [],
      leapsThreeRatingList: [],
      showAlertDialog: false,
      errorMsg: '',
      selectedOperation: '',
      selectedQuestionObj: null,
      prefixString: '',
      postString: '',
      showConfirmationBox: false
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay
  },
  methods: {
    addNewReflectionQuestion: function (currRating) {
      let routeData = this.$router.resolve({name: 'groups', query: {openCreatePopUp: 'true', currRating: currRating, groupId: this.selectedGroupObj.GroupId}})
      window.open(routeData.href, '_blank')
    },
    performInitOperations: function () {
      window.onfocus = () => {
        // this.getLeapsReflectionList()
      }
    },
    showQuestionTextUser: function (currSelectedObj, currRatingValue) {
      var listToAssign = this.leapsReflectionList
      switch (currRatingValue) {
        case 1:
          listToAssign = this.leapsOneRatingList
          break
        case 2:
          listToAssign = this.leapsTwoRatingList
          break
        case 3:
          listToAssign = this.leapsThreeRatingList
          break
      }
      const foundIndex = findIndex(listToAssign, (obj) => {
        return obj.MeetingMentorReflectionId === currSelectedObj.MeetingMentorReflectionId
      })
      if (foundIndex > -1) {
        switch (currRatingValue) {
          case 1:
            this.leapsOneRatingList = []
            this.leapsOneRatingList = listToAssign
            this.leapsOneRatingList[foundIndex].updatedIndex = this.leapsOneRatingList[foundIndex].Index
            this.leapsOneRatingList[foundIndex].updatedLongQuestionText = this.leapsOneRatingList[foundIndex].LongQuestion
            this.leapsOneRatingList[foundIndex].updatedShortQuestionText = this.leapsOneRatingList[foundIndex].ShortQuestion
            this.leapsOneRatingList[foundIndex].showLongQueEditTextBox = false
            this.leapsOneRatingList[foundIndex].showShortQueEditTextBox = false
            this.leapsOneRatingList[foundIndex].showIndexEditTextBox = false
            break
          case 2:
            this.leapsTwoRatingList = []
            this.leapsTwoRatingList = listToAssign
            this.leapsTwoRatingList[foundIndex].updatedIndex = this.leapsTwoRatingList[foundIndex].Index
            this.leapsTwoRatingList[foundIndex].updatedLongQuestionText = this.leapsTwoRatingList[foundIndex].LongQuestion
            this.leapsTwoRatingList[foundIndex].updatedShortQuestionText = this.leapsTwoRatingList[foundIndex].ShortQuestion
            this.leapsTwoRatingList[foundIndex].showLongQueEditTextBox = false
            this.leapsTwoRatingList[foundIndex].showShortQueEditTextBox = false
            this.leapsTwoRatingList[foundIndex].showIndexEditTextBox = false
            break
          case 3:
            this.leapsThreeRatingList = []
            this.leapsThreeRatingList = listToAssign
            this.leapsThreeRatingList[foundIndex].updatedIndex = this.leapsThreeRatingList[foundIndex].Index
            this.leapsThreeRatingList[foundIndex].updatedLongQuestionText = this.leapsThreeRatingList[foundIndex].LongQuestion
            this.leapsThreeRatingList[foundIndex].updatedShortQuestionText = this.leapsThreeRatingList[foundIndex].ShortQuestion
            this.leapsThreeRatingList[foundIndex].showLongQueEditTextBox = false
            this.leapsThreeRatingList[foundIndex].showShortQueEditTextBox = false
            this.leapsThreeRatingList[foundIndex].showIndexEditTextBox = false
            break
        }
      }
    },
    updateQuestion: function (objToUpdate) {
      var isNonNumeric = /[^$,.\d]/
      if (objToUpdate.updatedIndex !== null && objToUpdate.updatedIndex !== 'undefined' && objToUpdate.updatedIndex !== null && objToUpdate.updatedIndex !== 'null' && objToUpdate.updatedIndex !== '') {
        var nonNumericResult = objToUpdate.updatedIndex.toString().match(isNonNumeric)
        if (!nonNumericResult) {
          if (objToUpdate.updatedShortQuestionText !== undefined && objToUpdate.updatedShortQuestionText !== 'undefined' && objToUpdate.updatedShortQuestionText !== null && objToUpdate.updatedShortQuestionText !== 'null' && objToUpdate.updatedShortQuestionText.trim().length !== 0) {
            if (objToUpdate.updatedLongQuestionText !== undefined && objToUpdate.updatedLongQuestionText !== 'undefined' && objToUpdate.updatedLongQuestionText !== null && objToUpdate.updatedLongQuestionText !== 'null' && objToUpdate.updatedLongQuestionText.trim().length !== 0) {
              var objToPost = {
                MeetingMentorReflectionId: objToUpdate.MeetingMentorReflectionId,
                GroupId: objToUpdate.GroupId,
                Rating: objToUpdate.Rating,
                Index: objToUpdate.updatedIndex,
                LongQuestion: objToUpdate.updatedLongQuestionText,
                ShortQuestion: objToUpdate.updatedShortQuestionText
              }
              this.editCurrentSelectedAttachedLeapsQuestionText(objToPost)
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Long Question Text Can\'t be empty.'
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Short Question Text Can\'t be empty.'
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Index must be non-empty positive numeric value.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Index must be non-empty positive numeric value.'
      }
    },
    editCurrentSelectedAttachedLeapsQuestionText: function (objToPost) {
      var storeObj = this.$store
      this.$store.state.isLoading = true
      leapsChallengesService
        .updateCurrentReflectionQuestion(
          storeObj.state.access_token,
          objToPost
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            this.$store.state.isLoading = false
            this.checkAndPerformSelectedAction('edit', responseObj.data)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            this.$store.state.isLoading = false
          }
        }, errorObj => {
          this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    getLeapsReflectionList: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        this.$store.state.isLoading = true
        leapsChallengesService
          .getLeapsReflectionList(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.setDefaultValues(responseObj.data)
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEAPS REFLECTION LIST'
        )
      }
    },
    setDefaultValues: function (responseObj) {
      this.leapsReflectionList = filter(responseObj, (obj) => {
        return this.selectedGroupObj.GroupId === obj.GroupId
      })
      // AK: Add Extra properties into it.
      forEach(this.leapsReflectionList, (obj) => {
        obj.showLongQueEditTextBox = false
        obj.showShortQueEditTextBox = false
        obj.showIndexEditTextBox = false
        obj.updatedLongQuestionText = obj.LongQuestion
        obj.updatedShortQuestionText = obj.ShortQuestion
        obj.updatedIndex = obj.Index
      })
      // AK: Filter it out and store it in each array
      this.leapsOneRatingList = filter(this.leapsReflectionList, (obj) => {
        return parseInt(obj.Rating) === 1
      })
      this.leapsOneRatingList = sortBy(this.leapsOneRatingList, ['Index'])
      this.leapsTwoRatingList = filter(this.leapsReflectionList, (obj) => {
        return parseInt(obj.Rating) === 2
      })
      this.leapsTwoRatingList = sortBy(this.leapsTwoRatingList, ['Index'])
      this.leapsThreeRatingList = filter(this.leapsReflectionList, (obj) => {
        return parseInt(obj.Rating) === 3
      })
      this.leapsThreeRatingList = sortBy(this.leapsThreeRatingList, ['Index'])
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    checkAndPerformSelectedAction: function (isComingFrom, updatedRespObj) {
      const foundIndex = findIndex(this.leapsReflectionList, (obj) => {
        return obj.MeetingMentorReflectionId === this.selectedQuestionObj.MeetingMentorReflectionId
      })
      if (foundIndex > -1) {
        switch (isComingFrom) {
          case 'delete':
            this.leapsReflectionList.splice(foundIndex, 1)
            break
          case 'edit':
            this.leapsReflectionList[foundIndex] = updatedRespObj
            break
        }
      }
      console.log('foundIndex: ' + foundIndex + 'this.leapsReflectionList[foundIndex]: ' + JSON.stringify(this.leapsReflectionList[foundIndex]) + ' updatedRespObj: ' + updatedRespObj)
      this.setDefaultValues(this.leapsReflectionList)
    },
    userConfirmation (value) {
      this.showConfirmationBox = false
      if (value) {
        switch (this.selectedOperation) {
          case 'delete-reflection':
            this.deleteCurrentSelectedAttachedLeapsQuestionText()
            break
        }
      }
    },
    deleteCurrentSelectedAttachedLeapsQuestionText: function () {
      var storeObj = this.$store
      this.$store.state.isLoading = true
      leapsChallengesService
        .deleteCurrentReflectionQuestion(
          storeObj.state.access_token,
          this.selectedQuestionObj.MeetingMentorReflectionId
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            this.$store.state.isLoading = false
            this.checkAndPerformSelectedAction('delete', null)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            this.$store.state.isLoading = false
          }
        }, errorObj => {
          this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confirmation overlay
      this.showConfirmationBox = value
    },
    performClickOperation: function (event, operationName, selectedObj, currRatingValue) {
      this.selectedOperation = operationName
      this.selectedQuestionObj = selectedObj
      switch (this.selectedOperation) {
        case 'delete-reflection':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete '
          this.postString = 'selected question?'
          break
        case 'edit-reflection':
          var listToAssign = this.leapsReflectionList
          switch (currRatingValue) {
            case 1:
              listToAssign = this.leapsOneRatingList
              break
            case 2:
              listToAssign = this.leapsTwoRatingList
              break
            case 3:
              listToAssign = this.leapsThreeRatingList
              break
          }
          const foundIndex = findIndex(listToAssign, (obj) => {
            return obj.MeetingMentorReflectionId === selectedObj.MeetingMentorReflectionId
          })
          listToAssign = sortBy(listToAssign, ['Index'])
          if (foundIndex > -1) {
            switch (currRatingValue) {
              case 1:
                this.leapsOneRatingList = []
                this.leapsOneRatingList = listToAssign
                this.leapsOneRatingList[foundIndex].showLongQueEditTextBox = true
                this.leapsOneRatingList[foundIndex].showShortQueEditTextBox = true
                this.leapsOneRatingList[foundIndex].showIndexEditTextBox = true
                break
              case 2:
                this.leapsTwoRatingList = []
                this.leapsTwoRatingList = listToAssign
                this.leapsTwoRatingList[foundIndex].showLongQueEditTextBox = true
                this.leapsTwoRatingList[foundIndex].showShortQueEditTextBox = true
                this.leapsTwoRatingList[foundIndex].showIndexEditTextBox = true
                break
              case 3:
                this.leapsThreeRatingList = []
                this.leapsThreeRatingList = listToAssign
                this.leapsThreeRatingList[foundIndex].showLongQueEditTextBox = true
                this.leapsThreeRatingList[foundIndex].showShortQueEditTextBox = true
                this.leapsThreeRatingList[foundIndex].showIndexEditTextBox = true
                break
            }
          }
          break
      }
    },
    closeCurrentOverlay: function () {
      var objToReturn = {
        operationName: 'close_overlay',
        createdObj: null
      }
      this.$emit('updateValues', objToReturn)
    }
  },
  computed: {
    getSelectedGroupObjValue: {
      get: function () {
        return this.selectedGroupObj
      }
    }
  }
}
</script>

<style scoped>
.text-wrap {
  white-space: pre-line;
}
.border-1px-solid-blue {
  border: 1px solid blue;
  padding: 5px 10px;
}
.font-size-14px {
  font-size: 14px;
}
.text-color-blue {
  color: blue;
}
.padding-right-0px {
  padding-right: 0px;
}
.padding-left-0px {
  padding-left: 0px;
}
.font-size-18px {
  font-size: 18px;
}
.margin-bottom-0px {
  margin-bottom: 0px;
}
.padding-left-right-0Px {
  padding-left: 0px;
  padding-right: 0px;
}
.cursor-default  {
  cursor: not-allowed !important;
}
.opacity-point-2 {
  opacity: 0.2;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.font-size-11px {
  font-size: 11px;
}
.overlay-content {
  position: relative;
  top: 10%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-16px {
  font-size: 16px !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-align-left {
  text-align: left !important;
}
.text-align-center {
  text-align: center !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.course-img-width-height {
  width: 350px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #f39c12;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
.margin-top-3Perc {
  margin-top: 3% !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.opacity-1 {
  opacity: 1 !important;
}
.opacity-0 {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/group/ViewAssociatedLeapsReflectionForGroup.vue